import { Asset } from 'src/app/api/asset/asset';
import { AssetSearchResult } from 'src/app/api/asset/search/assetSearchResult';
import { Location } from 'src/app/api/location/location';
import { Site } from 'src/app/api/site/site';
import { getAssetDisplayName } from 'src/app/utils/asset-utils';

export class LocationTreeNode {
    assetId: string | null | undefined;
    siteId: number | null | undefined;
    name: string | null | undefined;
    children: LocationTreeNode[];
    underlyingData: Site | Location | Asset | null;
    assetsLoaded: boolean = false;
    type: string = "location";

    constructor() {
        this.children = [];
        this.underlyingData = null;
        this.assetsLoaded = false;
    }

    get underlyingAsset(): Asset | null {
        return this.underlyingData as Asset;
    }

    get underlyingLocation(): Location | null {
        return this.underlyingData as Location;
    }

    get underlyingSite(): Site | null {
        return this.underlyingData as Site;
    }

    hasChildren(): boolean {
        return (this.children.length > 0 || !this.assetsLoaded) && this.type != "asset";
    }

    static compare(x: LocationTreeNode, y: LocationTreeNode): number {
        if (x.type === 'asset' && y.type !== 'asset') return 1;
        if (x.type !== 'asset' && y.type === 'asset') return -1;
        
        return (x.name ?? '').localeCompare(y.name ?? '');
    }

    static fromLocation(location: Location): LocationTreeNode {
        var data = new LocationTreeNode();
        data.siteId = null;
        data.assetId = null;
        data.name = location.name;
        data.children = location.location ? location.location
            .map(x => LocationTreeNode.fromLocation(x))
            .sort(LocationTreeNode.compare)
            : [];

        data.underlyingData = location;
        data.type = "location";

        return data;
    }

    static fromAsset(asset: AssetSearchResult): LocationTreeNode {
        var data = new LocationTreeNode();
        data.siteId = null;
        data.assetId = asset.assetId;
        data.assetsLoaded = true;

        data.name = getAssetDisplayName(asset);
        data.children = [];
        data.type = "asset";

        return data;
    }

    static fromSite(site: Site): LocationTreeNode {
        var data = new LocationTreeNode();
        data.underlyingData = site;
        data.siteId = site.id;
        data.assetId = null;
        data.name = site.name;
        data.type = "site";
        data.children = site.locations ? site.locations
            .map(x => LocationTreeNode.fromLocation(x))
            .sort(LocationTreeNode.compare)
            : [];

        return data;
    }
}
